module.exports = __webpack_public_path__ + "media/src/website/images/locations/burghausen/profile-20caf28954bc81383f7bbd3287c9e23a.jpg";